import React, {ReactNode} from 'react';
import WithComponentErrorBoundary from 'Shared/components/WithComponentErrorBoundary';

type ErrorBoundaryProps = {
  children: ReactNode;
};

const ErrorBoundary = ({children}: ErrorBoundaryProps) => {
  return <>{children}</>;
};

export default WithComponentErrorBoundary(ErrorBoundary);
